import React from "react";
import tw from "twin.macro";
import Section1 from "../Components/Homepage/Section1";
import Section2 from "../Components/Homepage/Section2";
import RequestService from "../Components/requestService.js";
import Testimonial from "../Components/Testimonial/Testimonial";

import HomePageVideo from "../Images/herovideo.mp4";
import LoadingSpinner from "../Components/LoadingSpinner";

const Container = tw.div`relative md:mb-0 mb-40`;
const TextContainer = tw.div``;
const VideoContainer = tw.div`relative `;

const CenterTextContainer = tw.div`absolute text-center text-white text-6xl`;
const CenterText = tw.div`relative  `;

export default () => {
  return (
    <Container>
      {/* <LoadingSpinner /> */}
      <VideoContainer>
        <video autoPlay muted loop class="videoBG">
          <source src={HomePageVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <CenterTextContainer className="CenterTextContainer">
          <CenterText className="CenterText">
            BUILDING WITH INTEGRITY & VISION
          </CenterText>
        </CenterTextContainer>
      </VideoContainer>
      <RequestService />

      <Section1 />
      <Section2 />

      <Testimonial />
    </Container>
  );
};
